<template>
  <div>
    <p class="headline">
      <v-icon style="margin-top:-5px;">today</v-icon> Manage Schedule
      <small>a daily event schedule</small>
    </p>
    <v-breadcrumbs :items="items">
      <template v-slot:item="props">
        <v-icon v-if="props.item.icon" style="color:#fff;">{{props.item.icon}}</v-icon>
        <v-breadcrumbs-item
          @click.prevent="props.item.href"
          :class="[props.item.disabled && 'disabled']"
        >{{ props.item.text.toUpperCase() }}</v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

<!-- Tab Start -->
<v-row>
    <v-col cols="12" md="12">
        <v-card
        :style="$vuetify.breakpoint.lgAndUp?'width: 90%;':'width: 100%;'" 
        >
            <v-card-title>
              <v-btn color="primary" tile @click="newSchedule">Create Schedule</v-btn>
              <v-text-field
                    class="ml-4"
                    style="max-width: 350px;"
                    dense
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>

            <v-card-text>
              <v-data-table
              :items="schedules"
              :headers="headers"
              :items-per-page="10"
              v-model="selected"
              single-select
              :search="search"
              dense
              
              :footer-props="{
                    itemsPerPageOptions: [10,20,30,50,100,-1]
                }"
              >
              <template v-slot:item="{item}">
                <tr style="cursor: pointer;" @click="selectRow(item)" :key="item.id" :id="'sc'+item.id" :class="'sc'+item.id">
                  <td>{{item.name}}</td>
                  <td>{{formatedDate(item.updated_at)}}</td>
                  <td>
                    <v-icon small @click="editItem(item)">edit</v-icon>
                    <v-icon small @click="deleteItem(item)">delete</v-icon>
                  </td>
                </tr>
              </template>
             
              </v-data-table>
            </v-card-text>

        </v-card>
    </v-col>
</v-row>
<!-- Tab closed -->
      <v-expansion-panels 
      :style="$vuetify.breakpoint.lgAndUp?'width: 90%;':'width: 100%;'"
        multiple
        v-model="panel">
          <day v-for="(dayName, index) in days"
          :key="index+customIndex"
          :dayName="dayName"
          :isValidForm="isValidForm"
          :scheduleName="schedule_name"
          :dayParts="dayParts[index]" 
          :selectedSchedule="selectedSchedule"
          :channels="channels"
          :dow="(index+1)" 
          :getScheduleSettings="getScheduleSettings"
          :playlists="playlists"
          
          ></day>
      </v-expansion-panels>

    <v-dialog v-model="dialog" persistent max-width="600">
    <v-card tile>
        <v-card-title>Edit Schedule</v-card-title>
        <v-card-text>
            <v-form ref="scheduleForm">
                <v-col>
                  <v-text-field 
                    label="Name" 
                    :rules="[
                    (v)=> !!v||'This field is required.'
                    ]" 
                    v-model="currentSchedule.name">
                  </v-text-field>
                </v-col>
                <v-col>
                <v-text-field 
                    label="Description" 
                    v-model="currentSchedule.description" 
                    maxlength="128"></v-text-field>
                </v-col>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" tile @click="close">Close</v-btn>
            <v-btn color="primary" tile class="mr-4" @click.prevent="updateSchedule">Save</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

<v-dialog v-model="addScheduleDialog" max-width="500" >
  <v-card>
    <v-card-title>Add Schedule</v-card-title>
    <v-card-text>
      <v-form ref="addScheduleForm">
      <v-text-field 
      label="Enter schedule name"
      :rules="[
      (v) => !!v || 'This field is required'
      ]" 
      v-model="addScheduleName"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="denger" tile @click="closeAddSchedule">Cancle</v-btn>
      <v-btn color="primary" tile @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog 
    max-width="400"
    v-model="deleteDialog">
    <v-card tile>
        <v-card-title>Are you sure?</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
            <p class="title">You want to delete this schedule?</p>
            <div v-if="currentSchedule" class="user-info">
                <p class="mb-1">Schedule name: {{currentSchedule.name}}</p>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.prevent="deleteDialogClose" tile >No</v-btn>
            <v-btn color="red accent-4" @click.prevent="confirmDelete" tile class="white--text">Yes</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
  </div>
</template>

<script>
import axios from './axios'
import Day from './Day.vue'
import moment from 'moment'
export default {
  data() {
    return {
        customIndex: 1,
        search: '',
        selected: [],
        dialog: false,
        addScheduleDialog: false,
        addScheduleName: '',
        deleteDialog: false,
        days:['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
        tab: null,
        schedule_name: '',
        isValidForm: false,
        invalidScheduleName: false,
        playlists:[],
        items: [
          {
            text: "Manage Schedule",
            disabled: true,
            href: "/admin/schedules",
            icon: 'today'
          }
        ],
        schedules: [],
        selectedSchedule: null,
        channels: [],
        dayParts: [],
        panel: [1,2,3,4,5,6,7,0],
        currentSchedule: {
          id:0,
          name: '',
          description: ''
        },
        headers: [
          {text:'Name', value:'name'},
          {text: 'Date Saved', value: 'updated_at'},
          {text: 'Action', value: 'actions', width:'15%'}
        ]
    };
  },
  components:{
    Day
  },
  methods:{
    formatedDate(date){
      return moment(date).format('MM-DD-YYYY')
    },
      newSchedule(){
        this.addScheduleDialog = true
      },
      closeAddSchedule(){
        this.addScheduleDialog = false
        this.addScheduleName = ''
        setTimeout(()=>{
            this.$refs.addScheduleForm.reset()
            this.$refs.addScheduleForm.resetValidation()
        },100)
      },
      save(){
        if(!this.$refs.addScheduleForm.validate()) return 
        let data = {
          name: this.addScheduleName,
          description: ''
        }
        axios.post('/schedule', data, {
          params:{
            token: this.$store.getters.getToken,
            user_id: this.$store.getters.getUser
          }
        })
        .then(response=>{
          let sc = {
            name: data.name,
            description: '',
            id: response.data.schedule_id
          }

          this.schedules.unshift(sc)
          // this.selected=[]
          // this.selected.push(sc)
          if(this.schedules.length > 0){
          this.schedules.forEach(dp=>{
                let el = document.getElementById('sc'+dp.id)
                if(el){
                  el.classList.remove('selected-row')
                }
                
            })
          }
          
          setTimeout(()=>{
                let el = document.getElementById('sc'+response.data.schedule_id)
                  el.classList.add("selected-row")
              }, 100)

          this.onScheduleChange(response.data.schedule_id)

        })
        .catch(error=>{
          console.log(error.response)
        })

        this.closeAddSchedule()
      },
      selectRow(item){
        // this.selected=[]
        // this.selected.push(item)
        // this.onScheduleChange(item.id)
        if(this.schedules.length > 0){
          this.schedules.forEach(dp=>{
              let el = document.getElementById('sc'+dp.id)
              if(el){
                el.classList.remove('selected-row')
              }
              
          })
        }

        let selectedEl = document.getElementById('sc'+item.id)
        selectedEl.classList.add("selected-row")

        this.onScheduleChange(item.id)
      },
      deleteDialogClose(){
        this.deleteDialog = false
      },
      deleteItem(item){
        this.currentSchedule = Object.assign({}, item)
        this.deleteDialog = true
      },
      confirmDelete(){
        axios.delete('schedule/'+this.selectedSchedule,
            {
              params: {
                  token: this.$store.getters.getToken,
                  user_id: this.$store.getters.getUser
              }
            })
            .then(response=>{
                this.$store.dispatch('setAlert', response.data.message)
                this.selectedSchedule = null

                this.getSchedules()
                .then(response=>{
                  this.schedules = response.data.schedules
                })

                this.dayParts = []
                for (let index = 1; index < 8; index++) {
                  this.dayParts.push([])
                }
                localStorage.removeItem('scheduleId')
                this.deleteDialog = false
            })
            .catch(error=>{
                this.$store.dispatch('setErrorAlert', error.response.data.message)
            })
      },
      close(){
        this.dialog = false
        setTimeout(()=>{
              
        },100)
      },
      editItem(){
        this.dialog = true
      },
      updateSchedule(){
        let formData ={
          name: this.currentSchedule.name,
          description: this.currentSchedule.description
        }

        axios.put('schedule/'+this.selectedSchedule, formData,
          {
            params: {
                token: this.$store.getters.getToken,
                user_id: this.$store.getters.getUser
            }
          })
          .then(response=>{
              this.$store.dispatch("setAlert", response.data.message)
              this.dialog = false
              this.$refs.scheduleForm.reset()
                this.getSchedules()
                .then(response=>{
                  this.schedules = response.data.schedules
                  let currentSchedule = this.schedules.filter(schedule=>{
                    return schedule.id == this.currentSchedule.id
                  })
                  this.currentSchedule = currentSchedule[0]
                })
          })
          .catch(error=>{
              this.$store.dispatch('setErrorAlert', error.response.data.message)
          })
      },
      addScheduleTab(){
        this.tab = 'tab-add-schedule'
        localStorage.setItem('tab', this.tab)
        this.selectedSchedule = null
        localStorage.removeItem('scheduleId')
        this.dayParts = []
        this.invalidScheduleName = false
        this.$store.dispatch('setScheduleId', 0)

        for (let index = 1; index < 8; index++) {
          this.dayParts.push([])
        }
      },
      editScheduleTab(){
        this.selectedSchedule = null
        this.tab = 'tab-edit-schedule'
        localStorage.setItem('tab', this.tab)
        this.invalidScheduleName = false
        this.schedule_name = ''
        this.dayParts = []
        this.$store.dispatch('setScheduleId', 0)
        for (let index = 1; index < 8; index++) {
          this.dayParts.push([])
        }

        this.getSchedules()
          .then(response=>{
            this.schedules = response.data.schedules
          })
          .catch(error=>{
            console.log(error)
          })
      },
      onScheduleChange(event){
        this.customIndex++
        this.panel = [0,1,2,3,4,5,6,7,0]
        this.selectedSchedule = event
        let currentSchedule = this.schedules.filter(schedule=>{
          return schedule.id == event
        })
        this.currentSchedule = Object.assign({}, currentSchedule[0])

        localStorage.setItem('scheduleId', event)
        axios.get('/schedule/'+event,{
            params: {
                token: this.$store.getters.getToken,
                user_id: this.$store.getters.getUser
            }
          })
          .then(response=>{
              let data = response.data.items
              this.dayParts = []
              for (let index = 1; index < 8; index++) {
                this.dayParts.push(data.filter(el=>{return el.dow==index}))
              }
          })

          
      },
      getScheduleSettings(id){
        this.selectedSchedule = this.selectedSchedule?this.selectedSchedule:id
        axios.get('/schedule/'+this.selectedSchedule,
          {
            params: {
                token: this.$store.getters.getToken,
                user_id: this.$store.getters.getUser
            }
          })
          .then(response=>{
              let data = response.data.items
              this.dayParts = []
              for (let index = 1; index < 8; index++) {
                this.dayParts.push(data.filter(el=>{return el.dow==index}))
              }

          })
          .catch(error=>{
              this.$store.dispatch('setErrorAlert', error.response.data.message)
          })
          
      },
      getSchedules(){
        return axios.get('/schedule',{
            params: {
                token: this.$store.getters.getToken,
                user_id: this.$store.getters.getUser
            }
          })
      }
  },
  watch:{
    schedule_name:function(val){
      if(this.schedule_name == ""){
        this.invalidScheduleName=true 
        this.isValidForm = false
      }else{
        this.invalidScheduleName=false
        this.isValidForm = true
      }
    }
  },
  created(){
    for (let index = 1; index < 8; index++) {
      this.dayParts.push([])
    }

    let id = this.$route.params.id

    this.getSchedules()
      .then(response=>{
            this.schedules = response.data.schedules
            if( id > 0){
              let selectedSchedule = this.schedules.filter(r=>{
                return r.id == id
              })

              let schedule = selectedSchedule[0]
              this.selectedSchedule = schedule.id
              this.onScheduleChange(this.selectedSchedule)
              this.selected.push(schedule)
            }else if(id == 0 || id == '' || id == null){
              let id = localStorage.getItem('scheduleId')
              if(id > 0){
                let selectedSchedule = this.schedules.filter(r=>{
                 return r.id == id
                })

                let schedule = selectedSchedule[0]
                this.selectedSchedule = schedule.id
                this.onScheduleChange(this.selectedSchedule)
                this.selected.push(schedule)
              }
            }
      })

    axios.get('/channels?token='+this.$store.getters.getToken)
        .then(response=>{
          this.channels = response.data.channels
          let channel = {
            id: 0,
            name: 'No channnel',
            channel_id: 0,
            channel_guid: 0,
            short_name: 'No channnel',
            streaming_name: 'No channnel',
            sort_order: 0,
            channel_number: 0,
            created_at: '',
            updated_at: ''
          }

          // let no_change = {
          //   id: -1,
          //   name: 'None - No change',
          //   channel_id: -1,
          //   channel_guid: 0,
          //   short_name: 'Stop Playing',
          //   streaming_name: 'Stop Playing',
          //   sort_order: 0,
          //   channel_number: -1,
          //   created_at: '',
          //   updated_at: ''
          // }

          let no_channel = {
            id:-2,
            name: 'No channnel',
            channel_id:-2,
            channel_guid: 0,
            short_name: 'No channnel',
            streaming_name: 'No channnel',
            sort_order: 0,
            channel_number:-2,
            created_at: '',
            updated_at: ''
          }

          this.channels.unshift(channel)
          // this.channels.unshift(no_change)
          // this.channels.unshift(no_channel)
        })
        .catch(error=>{
          this.$store.dispatch('setErrorAlert', error.response.data.message)
        })

    axios.get('playlist', {
      params:{
        token: this.$store.getters.getToken,
        user_id: this.$store.getters.getUser
      }
    })
    .then(response=>{

      // let no_change = {
      //   created_at: '',
      //   duration: '',
      //   id: -1,
      //   messages: '',
      //   name: 'None - No Change',
      //   updated_at: '',
      //   uploaded_by: '',
      //   user_id: ''
      // }

      let no_playlist = {
        created_at: '',
        duration: '',
        id: -2,
        messages: '',
        name: 'No Playlist',
        updated_at: '',
        uploaded_by: '',
        user_id: ''
      }

      this.playlists = response.data.playlists
      // this.playlists.unshift(no_change)
      this.playlists.unshift(no_playlist)
      
    })
    .catch(error=>{
      console.log(error.response)
    })

    
    this.tab = localStorage.getItem('tab')
    localStorage.setItem('currentUrl', '/admin/schedules')
  }
}
</script>

<style scoped>
.v-breadcrumbs {
  background-color: #0f4e74;
  padding: 6px 8px;
  color: #fff;
}
.v-breadcrumbs__item {
  color: #fff;
}
.radio-time-picker{
  width: 100%;
}

.v-card__text, .v-card__title {
    padding: 8px 16px;
}
</style>